import { Badge as AntBadge, type BadgeProps } from 'antd'

export type UiBadgeProps = BadgeProps

/** Bọc mỏng: giữ nguyên API AntD. Mặc định không cắt số kiểu "99+" — hiện đủ giá trị. */
export const UiBadge = ({ overflowCount = Number.MAX_SAFE_INTEGER, ...props }: UiBadgeProps) => (
  <AntBadge overflowCount={overflowCount} {...props} />
)

export default UiBadge
